@if (isLink(item) && !isFunction(item.route)) {
  <a
    [fragment]="item.fragment"
    [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
    [routerLink]="item.route"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="item.label | translate"
    matTooltipPosition="right"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    class="vex-sidenav-item rounded"
    matRipple
    matRippleColor="var(--vex-sidenav-item-ripple-color)"
    routerLinkActive="vex-sidenav-item--active"
    [ngClass]="isHover || linkElement.isActive ? item.hoverBgClass : ''"
    [class.vex-sidenav-item-custom]="isWhiteLabelCustomization"
    #linkElement="routerLinkActive">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || linkElement.isActive ? item.hoverIcon || item.icon : item.icon"
        class="vex-sidenav-item__icon" />
    }
    <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[
          item.badge.bgClass,
          item.badge.textClass,
          linkElement.isActive ? item.badge.activeBgClass || '' : ''
        ]"
        [style.background-color]="
          linkElement.isActive && item.badge.activeBgColor ? item.badge.activeBgColor : item.badge.bgColor
        "
        class="vex-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
  </a>
}

@if (isLink(item) && isFunction(item.route)) {
  <div
    (click)="item.route()"
    (keydown.enter)="item.route()"
    class="vex-sidenav-item rounded"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    matRipple
    matRippleColor="var(--vex-sidenav-item-ripple-color)"
    routerLinkActive="vex-sidenav-item--active"
    tabindex="0"
    role="button"
    #linkElement="routerLinkActive">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || linkElement.isActive ? item.hoverIcon || item.icon : item.icon"
        class="vex-sidenav-item__icon" />
    }
    <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        [style.background-color]="item.badge.bgColor"
        class="vex-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
  </div>
}

@if (isCallback(item)) {
  <div
    (click)="item.onClick()"
    (keydown.enter)="item.onClick()"
    [matTooltipDisabled]="!showTooltip"
    [matTooltip]="item.label | translate"
    matTooltipPosition="right"
    (mouseenter)="hoverIcon()"
    (mouseleave)="hoverOutIcon()"
    [class.vex-sidenav-item--active]="item.isActive"
    [ngClass]="isHover || item.isActive ? item.hoverBgClass : ''"
    [class.vex-sidenav-item-custom]="isWhiteLabelCustomization"
    class="vex-sidenav-item rounded"
    matRipple
    matRippleColor="var(--vex-sidenav-item-ripple-color)"
    tabindex="0"
    role="button">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover || item.isActive ? item.hoverIcon || item.icon : item.icon"
        class="vex-sidenav-item__icon" />
    }
    <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        class="vex-sidenav-item__badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass, item.isActive ? item.badge.activeBgClass || '' : '']"
        [style.background-color]="
          item.isActive && item.badge.activeBgColor ? item.badge.activeBgColor : item.badge.bgColor
        "
        [class.vex-sidenav-item__badge--empty]="!item.badge.value"
        >{{ item.badge.value }}</span
      >
    }
  </div>
}

@if (isDropdown(item)) {
  <div
    (click)="toggleOpen()"
    (keydown.enter)="toggleOpen()"
    [class.vex-sidenav-item--active]="isOpen || isActive"
    [class.vex-sidenav-item--open]="isOpen"
    class="vex-sidenav-item rounded"
    matRipple
    matRippleColor="var(--vex-sidenav-item-ripple-color)"
    tabindex="0"
    role="button">
    @if (level === 0 && item.icon) {
      <mat-icon
        [svgIcon]="isHover ? item.hoverIcon || item.icon : item.icon"
        class="vex-sidenav-item__icon" />
    }
    <span class="vex-sidenav-item__label">{{ item.label | translate }}</span>
    @if (item.badge) {
      <span
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        [style.background-color]="item.badge.bgColor"
        class="vex-sidenav-item__badge"
        >{{ item.badge.value }}</span
      >
    }
    <mat-icon
      class="vex-sidenav-item__dropdown-icon"
      svgIcon="mat:keyboard_arrow_right" />
  </div>
  <div
    [@dropdown]="isOpen"
    class="vex-sidenav-item__dropdown">
    @for (subItem of item.children; track subItem) {
      <rms-sidenav-item
        [item]="subItem"
        [level]="level + 1" />
    }
  </div>
}

@if (isSubheading(item)) {
  <div class="vex-sidenav-subheading">{{ item.label | translate }}</div>
  @for (subItem of item.children; track subItem) {
    <rms-sidenav-item
      [item]="subItem"
      [level]="0" />
  }
}
